import BaseModel from 'src/model/base.model';

class PowerUserModel extends BaseModel {
  public email: string = '';
  public fullName: string = '';
  public id: number = 0;
  public handler: string = '';
  public mobileNumber: string = '';
  public permission: any[] = [];
  public username: string = '';
}

export default PowerUserModel;
